import { daysFormat } from '@/filters'
import {
  setCheckButtons,
  setTableButtons,
  setFormButtons
} from '@/utils/getbuttons.js'
import {
  isLaborCompanyOrg,
  isEnterpriseViewOrg,
  getLaborParentBidUid,
  getLaborParentBidName,
  getLaborCompanyName,
  ENTERPRISE_DIRECT_VALUE,
  withEnterpriseDirectBidOption,
  isEnterpriseDirectValue,
  isTzInspectionOrg,
  TZ_INSPECTION_ORG_NAME
} from '@/utils/bidLevelActions.js'

const DEVICE_USAGE_OPTIONS = [
  { value: '起重吊装', label: '起重吊装' },
  { value: '钢筋加工', label: '钢筋加工' },
  { value: '桥梁架设', label: '桥梁架设' },
  { value: '预应力张拉', label: '预应力张拉' },
  { value: '混凝土拌和', label: '混凝土拌和' },
  { value: '稳定料拌和', label: '稳定料拌和' },
  { value: '沥青料拌和', label: '沥青料拌和' },
  { value: '燃油运输', label: '燃油运输' },
  { value: '稳定料摊铺', label: '稳定料摊铺' },
  { value: '沥青料摊铺', label: '沥青料摊铺' },
  { value: '混凝土滑膜作业', label: '混凝土滑膜作业' },
  { value: '混凝土泵送作业', label: '混凝土泵送作业' }
]

function optionalPositiveIntRule() {
  return {
    // 须包一层 (params)=>validator：getFormRules 会执行 validator(params)
    validator: () => {
      return (rule, value, callback) => {
        if (
          value === '' ||
          value === null ||
          value === undefined ||
          (typeof value === 'number' && isNaN(value))
        ) {
          callback()
          return
        }
        if (!/^[1-9]\d*$/.test(String(value))) {
          callback(new Error('请输入不为0的正整数'))
          return
        }
        callback()
      }
    },
    trigger: 'blur'
  }
}

function approvedPensonMaxRule() {
  return {
    validator: (params) => {
      return (rule, value, callback) => {
        if (
          value === '' ||
          value === null ||
          value === undefined ||
          (typeof value === 'number' && isNaN(value))
        ) {
          callback()
          return
        }
        if (!/^[1-9]\d*$/.test(String(value))) {
          callback(new Error('请输入不为0的正整数'))
          return
        }
        const form =
          (params.formValues &&
            (params.formValues.officialCar ||
              params.formValues.fixedEquipment)) ||
          {}
        const max = form.approvedPensonMax
        if (max != null && max !== '' && Number(value) > Number(max)) {
          callback(
            new Error('核载人数不可大于车辆参数中的核载人数（' + max + '）')
          )
          return
        }
        callback()
      }
    },
    trigger: 'blur'
  }
}

function listOrgUid(params) {
  if (isLaborCompanyOrg(params.orgType)) {
    return getLaborParentBidUid(params) || params.orgValue
  }
  return params.orgValue
}

function bidQueryUid(params) {
  if (params.orgType === 'simPro') return params.orgValue
  if (isLaborCompanyOrg(params.orgType)) {
    return getLaborParentBidUid(params)
  }
  if (isEnterpriseViewOrg(params.orgType)) {
    return ENTERPRISE_DIRECT_VALUE
  }
  return params.state.bidSection.subBidSection[0]
    ? params.state.bidSection.subBidSection[0].orgUid
    : ''
}

function bidFilterOptions(params) {
  return withEnterpriseDirectBidOption(
    params.state.bidSection.subBidSection,
    params.orgType
  )
}

function formBidUid(params) {
  if (isLaborCompanyOrg(params.orgType)) {
    return getLaborParentBidUid(params) || params.orgValue
  }
  return params.orgValue
}

function formBidName(params) {
  if (isLaborCompanyOrg(params.orgType)) {
    return getLaborParentBidName(params) || params.orgName
  }
  return params.orgName
}

function laborCompanyFieldKey(params) {
  if (isLaborCompanyOrg(params.orgType)) return null
  if (isEnterpriseViewOrg(params.orgType)) return null
  return params.pageStatus === 'check' || params.pageStatus === 'device'
    ? 'laborCompanyName'
    : 'laborCompany'
}

function showLaborCompanyQuery(params) {
  if (isLaborCompanyOrg(params.orgType)) return false
  if (!isEnterpriseViewOrg(params.orgType)) return true
  const bidUid = params.queryValues && params.queryValues.vprojectUid
  return bidUid && !isEnterpriseDirectValue(bidUid)
}

function tableActionButtons(params) {
  const names = isTzInspectionOrg(params)
    ? ['查看', '编辑', '删除']
    : ['查看', '编辑', '删除', '监控']
  return setTableButtons(names)
}

function statusColumns(params) {
  const cols = equipmentStatusColumns(params)
  if (!isTzInspectionOrg(params)) return cols
  return cols.filter((item) => item.prop === 'paramJsonInfo')
}

const MOBILE_TAB = {
  label: '移动机械',
  theme: 'officialCar',
  step: 'officialCarList',
  stepLabel: '移动机械列表',
  checkFun: 'officialCar/getOfficialCarList'
}

const FIXED_TAB = {
  label: '固定机械',
  theme: 'officialCar',
  step: 'fixedEquipmentList',
  stepLabel: '固定机械列表',
  checkFun: 'officialCar/getOfficialCarList'
}

const EQUIPMENT_LINK_PAGES = [
  {
    buttonName: '保险到期日期',
    name: 'insurance',
    type: 'drawerTable',
    checkType: 'checkByUid',
    checkFun: 'officialCar/getOfficialCarEnterInfo'
  },
  {
    buttonName: '最近保养日期',
    name: 'maintenance',
    type: 'drawerTable',
    checkType: 'checkByUid',
    checkFun: 'officialCar/getOfficialCarEnterInfo'
  },
  {
    buttonName: '最近检验日期',
    name: 'maintenance',
    type: 'drawerTable',
    checkType: 'checkByUid',
    checkFun: 'officialCar/getOfficialCarEnterInfo'
  },
  {
    buttonName: '运行监控状态',
    name: 'device',
    type: 'drawerTable',
    checkType: 'checkByUid',
    checkFun: 'officialCar/getOfficialCarEnterInfo'
  },
  {
    buttonName: '监控',
    name: 'deviceData',
    type: 'deviceData',
    label: '查看物联监控数据',
    theme: 'officialCar',
    step: 'deviceDataInfo',
    checkType: 'checkByUid',
    checkFun: 'officialCar/getOfficialCarEnterInfo',
    pageStatus: 'current'
  },
  {
    buttonName: '参数指标',
    name: 'paramJson',
    type: 'dialogForm',
    checkType: 'checkByKey',
    checkKey: 'carUid',
    checkFun: 'officialCar/getOfficialCarInfo',
    pageStatus: 'edit'
  }
]

function equipmentStatusColumns(params) {
  return [
    {
      prop: 'paramJsonInfo',
      label: '参数指标',
      drillDown: true,
      tooltip: { tipValue: '点击修改添加参数指标' },
      overflow: false,
      width: '260px'
    },
    {
      prop: 'isExpired',
      label: '保险状态',
      width: '80px',
      tag: params.dictionarys.isExpired
    },
    {
      prop: 'insuranceExpiryDate',
      label: '保险到期日期',
      drillDown: true,
      tooltip: { tipValue: '点击查看保险详情' }
    },
    {
      prop: 'latestMaintainDate',
      label: '最近保养日期',
      drillDown: true,
      tooltip: { tipValue: '点击查看维修保养详情' }
    },
    {
      prop: 'monitoringState',
      label: '运行监控状态',
      drillDown: true,
      tooltip: () => {
        return (row) => {
          return { tipValue: row.monitoringInfo }
        }
      },
      tag: [
        { includes: '离线', type: 'warning' },
        { label: '无监控', type: 'danger' },
        { includes: '在线-行驶', type: 'success' }
      ]
    }
  ]
}

const officialCar = {
  pageTabs: () => [MOBILE_TAB, FIXED_TAB],
  officialCar: {
    name: 'officialCar',
    componentTypes: [
      'navigate',
      'pageTabs',
      'check',
      'tables',
      'stepForm',
      'drawerTable',
      'dialogForm',
      'deviceData'
    ], // 该页面包含的组件名称，用于判断是否返回页面渲染参数
    addFun: 'officialCar/addOfficialCar',
    editFun: 'officialCar/editOfficialCarEnter',
    getListFun: 'officialCar/getOfficialCarList',
    deleteFun: 'officialCar/deleteOfficialCarEnter',
    detailPage: [
      {
        buttonName: '进场',
        name: 'officialCar',
        type: 'stepForm',
        theme: 'officialCar',
        step: 'officialCarInfo',
        label: '新增移动机械进场信息',
        pageStatus: 'add'
      },
      {
        buttonName: '编辑',
        name: 'officialCar',
        type: 'stepForm',
        theme: 'officialCar',
        step: 'officialCarInfo',
        label: '编辑移动机械进场信息',
        checkType: 'checkByUid',
        checkFun: 'officialCar/getOfficialCarEnterInfo'
      },
      {
        buttonName: '查看',
        name: 'officialCar',
        type: 'stepForm',
        theme: 'officialCar',
        step: 'officialCarInfo',
        label: '查看移动机械进场信息',
        checkType: 'checkByUid',
        checkFun: 'officialCar/getOfficialCarEnterInfo'
      },
      ...EQUIPMENT_LINK_PAGES
    ],
    headButtons: setCheckButtons(['进场']),
    queryParams: {
      orgUid: (params) => listOrgUid(params),
      vprojectUid: (params) => bidQueryUid(params),
      laborCompanyUid: (params) => {
        return isLaborCompanyOrg(params.orgType) ? params.orgValue : ''
      },
      exit: null,
      inspectExpired: '',
      hasGps: '',
      hasMonitoring: '',
      carUsage: '',
      query: '',
      isExpired: '',
      year: ''
    },
    selectData: (params) => {
      const tz = isTzInspectionOrg(params)
      const selectData = []
      if (!isLaborCompanyOrg(params.orgType)) {
        selectData.push({
          key: 'vprojectUid',
          label: '所属项目标段',
          type: 'select',
          options: bidFilterOptions(params),
          checkByValue: true
        })
        if (showLaborCompanyQuery(params)) {
          selectData.push({
            key: 'laborCompanyUid',
            label: '所属劳务公司',
            type: 'select',
            options: params.state.bidSection.laborCompanyNames,
            placeholder: '请先选择所属项目标段',
            checkByValue: true
          })
        }
      }
      selectData.push({
        key: tz ? 'inspectExpired' : 'exit',
        label: tz ? '是否过期' : '是否在场',
        type: 'select',
        options: tz
          ? [
              { value: '1', label: '已过期', type: 'danger' },
              { value: '0', label: '未过期' }
            ]
          : params.dictionarys.trueFalse,
        checkByValue: true
      })
      if (!tz) {
        selectData.push(
          {
            key: 'isExpired',
            label: '保险状态',
            type: 'select',
            options: params.dictionarys.isExpired
          },
          {
            key: 'hasMonitoring',
            label: '是否监控',
            type: 'select',
            options: params.dictionarys.isFalse
          }
        )
      }
      selectData.push(
        {
          key: 'carUsage',
          label: '车辆用途',
          type: 'select',
          options: params.dictionarys.carUsage
        },
        {
          key: 'query',
          label: '关键词',
          type: 'input',
          placeholder: tz
            ? '车牌号/车辆型号/所有人/检验机构'
            : '车牌号/车辆型号/车主姓名/司机姓名'
        }
      )
      return selectData
    },
    tagInfo:
      '移动机械状态保持页面打开初次或前一次点击查询按钮查询结果，想要查看最新状态，请点击查询按钮重新查询',
    outListHeight: (params) => {
      return isLaborCompanyOrg(params.orgType) ? 230 : 270
    },
    rowData: (params) => {
      return params.getters['officialCar/carLists']
    },
    rowTotal: (params) => {
      return params.state.officialCar.officialCarTotal
    },
    columns: (params) => {
      const tz = isTzInspectionOrg(params)
      return [
        {
          prop: 'carCode',
          label: '车牌号',
          tooltip: () => {
            return (row) => {
              return { tipValue: row.laborCompanyName }
            }
          }
        },
        {
          prop: 'carName',
          label: '设备名称'
        },
        {
          prop: tz ? 'ownerName' : 'driverName',
          label: tz ? '所有人' : '司机姓名',
          tooltip: () => {
            return (row) => {
              return { tipValue: tz ? row.ownerPhone : row.driverPhone }
            }
          },
          width: tz ? '160px' : '80px'
        },
        {
          prop: 'carUsage',
          label: '车辆用途',
          tooltip: () => {
            return (row) => {
              return { tipValue: row.carModel }
            }
          },
          tag: params.dictionarys.carUsage
        },
        {
          prop: 'entryDate',
          label: tz ? '初次检验日期' : '进场日期'
        },
        ...(tz
          ? [
              {
                prop: 'latestMaintainDate',
                label: '最近检验日期',
                drillDown: true,
                tooltip: { tipValue: '点击查看维修保养详情' }
              },
              {
                prop: 'inspectExpired',
                label: '是否过期',
                switch: 'nextMaintainDate',
                width: '160px'
              }
            ]
          : [
              {
                prop: 'exit',
                label: '是否退场',
                switch: 'exitDate',
                width: '140px'
              },
              {
                prop: 'limitSpeed',
                label: '最大限速'
              },
              {
                prop: 'approvedPenson',
                label: '核载人数'
              }
            ]),
        ...statusColumns(params),
        {
          label: '操作',
          width: tz ? '220px' : '280px',
          buttons: tableActionButtons(params)
        }
      ]
    },
    addArray: true,
    formParams: {
      vprojectUid: (params) => formBidUid(params),
      vprojectName: (params) => formBidName(params),
      laborCompanyUid: (params) => {
        return isLaborCompanyOrg(params.orgType) ? params.orgValue : ''
      },
      laborCompanyName: (params) => {
        return isLaborCompanyOrg(params.orgType)
          ? getLaborCompanyName(params)
          : ''
      },
      carCode: '',
      carName: '',
      carModel: '',
      ownerName: '',
      ownerCardNum: '',
      ownerPhone: '',
      driverName: (params) => {
        return isTzInspectionOrg(params) ? TZ_INSPECTION_ORG_NAME : ''
      },
      driverIdcard: '',
      driverPhone: '',
      entryDate: daysFormat(new Date()),
      exit: false,
      exitDate: '',
      approvedPenson: (params) => {
        return isTzInspectionOrg(params) ? 2 : null
      },
      approvedPensonMax: null,
      limitSpeed: null,
      carUsage: (params) => {
        return isTzInspectionOrg(params) ? '燃油运输' : ''
      },
      deviceCategory: '移动机械',
      vehicleLicense: [],
      fileLists: {
        vehicleLicense: []
      },
      isCheck: (params) => isTzInspectionOrg(params)
    },
    formRules: (params) => {
      const tz = isTzInspectionOrg(params)
      const rules = {
        carCode: [
          {
            required: true,
            message: '设备编号不能为空',
            trigger: 'blur'
          }
        ],
        carName: [
          {
            required: true,
            message: '设备名称不能为空',
            trigger: 'blur'
          }
        ],
        ownerName: [
          {
            required: true,
            message: '车主姓名不能为空',
            trigger: 'blur'
          }
        ],
        entryDate: [
          {
            required: true,
            message: tz ? '进场及初检日期不能为空' : '进场日期不能为空',
            trigger: 'blur'
          }
        ]
      }
      if (!tz) {
        rules.approvedPenson = [
          optionalPositiveIntRule(),
          approvedPensonMaxRule()
        ]
        rules.limitSpeed = [optionalPositiveIntRule()]
      }
      return rules
    },
    formData: (params) => {
      const tz = isTzInspectionOrg(params)
      return {
        card: tz ? '特种设备检验信息' : '移动机械信息',
        bottomButtons: setFormButtons(['取消', '提交']),
        manualUpload: true,
        fields: [
          {
            key: laborCompanyFieldKey(params),
            label: '所属劳务公司',
            type: 'select',
            options: params.state.bidSection.laborCompanyNames,
            placeholder: '请选择进场车辆所属劳务公司，项目直管车辆不用选择',
            valueKey: 'value',
            bindKeys: ['value', 'label'],
            formKeys: ['laborCompanyUid', 'laborCompanyName']
          },
          {
            key: 'carCode',
            label: '设备编号',
            type: 'select',
            options: params.state.officialCar.officialCars,
            placeholder:
              '请输入设备编号、设备名称或所有人搜索，搜不到可直接输入车牌号新增',
            filterable: true,
            create: true,
            remote: true,
            checkByValue: true,
            disabled: params.pageStatus === 'edit' ? true : false,
            inputTip:
              params.pageStatus === 'edit'
                ? '车牌号错误修改请直接删除重新进场'
                : ''
          },
          {
            key: 'carName',
            label: '设备名称',
            type: 'input',
            placeholder: '默认与车牌号相同，可修改'
          },
          {
            key: 'carModel',
            label: '车辆型号',
            type: 'input'
          },
          {
            key: 'approvedPenson',
            label: tz ? '荷载人数' : '核载人数',
            type: 'input',
            placeholder: tz
              ? '可不填，默认2人'
              : '选择车辆后按车辆参数核载人数填充，可改但不可大于该值',
            inputButton: '人',
            number: true
          },
          {
            key: 'ownerName',
            label: tz ? '所有人' : '车主姓名',
            type: 'input'
          },
          {
            key: 'ownerCardNum',
            label: tz ? '所有人证件号' : '车主身份证号',
            type: 'input'
          },
          {
            key: 'ownerPhone',
            label: tz ? '所有人联系电话' : '车主手机号码',
            type: 'input'
          },
          {
            key: 'entryDate',
            label: tz ? '进场及初检日期' : '进场日期',
            type: 'time',
            format: 'yyyy-MM-dd'
          },
          {
            key:
              tz ||
              (params.pageStatus !== 'edit' && params.pageStatus !== 'check')
                ? null
                : 'exitDate',
            label: '退场日期',
            type: 'time',
            format: 'yyyy-MM-dd'
          },
          tz
            ? { key: null }
            : {
                key: 'limitSpeed',
                label: '最大限速',
                type: 'input',
                placeholder:
                  '可不填，填写管理机构要求的工作路段最大限速，请输入不为0的正整数',
                inputButton: 'km/h',
                number: true
              },
          {
            key: 'driverName',
            label: tz ? '检验机构' : '司机姓名',
            type: tz ? 'input' : 'select',
            options: tz
              ? []
              : params.formValues && params.formValues.laborCompanyUid
              ? params.state.contractor.laborPersonNames
              : params.state.contractor.managePersonNames,
            filterable: !tz,
            create: !tz
          },
          tz
            ? { key: null }
            : {
                key: 'driverIdcard',
                label: '司机身份证号',
                type: 'input'
              },
          tz
            ? { key: null }
            : {
                key: 'driverPhone',
                label: '司机手机号码',
                type: 'input'
              },
          {
            key: 'carUsage',
            label: '车辆用途',
            type: 'select',
            options: params.dictionarys.carUsage
          },
          {
            key: 'vehicleLicense',
            label: '车辆证件',
            type: 'upload',
            autoUpload: false
          }
        ]
      }
    },
    hasPagination: true,
    insurance: {
      name: 'insurance',
      title: '车辆保险备案',
      deleteFun: 'insurance/deleteInsurance',
      addFun: 'insurance/addInsurance',
      editFun: 'insurance/editInsurance',
      getListFun: 'officialCar/getOfficialCarEnterInfo',
      getParentFun: 'officialCar/getOfficialCarList',
      headButtons: setCheckButtons(['新增']),
      detailPage: [
        {
          buttonName: '新增',
          name: 'insurance',
          type: 'dialogForm'
        },
        {
          buttonName: '编辑',
          name: 'insurance',
          type: 'dialogForm',
          checkType: 'useRowData'
        },
        {
          buttonName: '保单图片',
          name: 'insurance',
          type: 'preview'
        }
      ],
      rowData: (params) => {
        return params.state.insurance.insuranceList
      },
      columns: (params) => {
        var columns = [
          {
            label: '保单编号',
            prop: 'policyNumber',
            width: '200px'
          },
          {
            label: '投保人',
            prop: 'customer'
          },
          {
            label: '保险公司',
            prop: 'insuranceCompany',
            width: '200px',
            overflow: false
          },
          {
            label: '保险开始日期',
            prop: 'insuranceStartDate',
            type: 'date'
          },
          {
            label: '保险结束日期',
            prop: 'insuranceEndDate',
            type: 'date'
          },
          {
            label: '保险金额（万元）',
            prop: 'insuranceAmount',
            width: '100px'
          },
          {
            label: '保险费用（元）',
            prop: 'insurancePremium'
          },
          {
            label: '保单图片',
            prop: 'policyImageInfo',
            drillDown: true
          },
          {
            label: '备注',
            prop: 'mark',
            width: '300px'
          }
        ]
        if (
          params.state.officialCar.officialCarInfo.vprojectUid ===
            params.orgValue ||
          params.state.officialCar.officialCarInfo.laborCompanyUid ===
            params.orgValue
        ) {
          columns.push({
            label: '操作',
            buttons: setTableButtons(['编辑', '删除'])
          })
        }
        return columns
      },
      manualUpload: true,
      formParams: {
        insuredEntityUid: (params) => {
          return params.state.officialCar.officialCarInfo.carUid
        },
        insuredEntity: (params) => {
          return params.state.officialCar.officialCarInfo.carCode
        },
        customer: '',
        beneficiary: '',
        insuranceType: '车险',
        insuranceCompany: '',
        policyNumber: '',
        insuranceStartDate: '',
        insuranceEndDate: '',
        insuranceAmount: '',
        insurancePremium: '',
        mark: '',
        policyImage: [],
        fileLists: {
          policyImage: []
        }
      },
      formRules: {
        policyNumber: [
          {
            required: true,
            message: '保单编号不能为空',
            trigger: 'blur'
          }
        ],
        insuredEntity: [
          {
            required: true,
            message: '被保险主体不能为空',
            trigger: 'blur'
          }
        ],
        customer: [
          {
            required: true,
            message: '投保人不能为空',
            trigger: 'blur'
          }
        ],
        insuranceType: [
          {
            required: true,
            message: '保险类型不能为空',
            trigger: 'change'
          }
        ],
        insuranceCompany: [
          {
            required: true,
            message: '保险公司不能为空',
            trigger: 'blur'
          }
        ],
        insuranceStartDate: [
          {
            required: true,
            message: '保险开始日期不能为空',
            trigger: 'blur'
          }
        ],
        insuranceEndDate: [
          {
            required: true,
            message: '保险结束日期不能为空',
            trigger: 'blur'
          }
        ],
        insuranceAmount: [
          {
            required: true,
            message: '保险金额不能为空',
            trigger: 'blur'
          },
          {
            pattern: /^[1-9]\d*(\.\d+)?$/,
            message: '请输入大于等于0的数值',
            trigger: 'change'
          }
        ],
        policyImage: [
          {
            required: true,
            type: 'array',
            message: '请至少上传一张保单图片',
            trigger: 'change'
          }
        ]
      },
      formData: [
        {
          key: 'insuredEntity',
          label: '被保险主体',
          type: 'input',
          disabled: true
        },
        {
          key: 'policyNumber',
          label: '保单编号',
          type: 'input'
        },
        {
          key: 'customer',
          label: '投保人',
          type: 'input'
        },
        {
          key: 'beneficiary',
          label: '受益人',
          type: 'input'
        },
        {
          key: 'insuranceType',
          label: '保险类型',
          type: 'select',
          options: (params) => {
            return params.dictionarys.insuranceType
          }
        },
        {
          key: 'insuranceCompany',
          label: '保险公司',
          type: 'input'
        },
        {
          key: 'insuranceStartDate',
          label: '保险开始日期',
          type: 'time',
          format: 'yyyy-MM-dd'
        },
        {
          key: 'insuranceEndDate',
          label: '保险结束日期',
          type: 'time',
          format: 'yyyy-MM-dd'
        },
        {
          key: 'insuranceAmount',
          label: '保险金额',
          type: 'input',
          inputButton: '万元',
          number: 6
        },
        {
          key: 'insurancePremium',
          label: '保险费用',
          type: 'input',
          inputButton: '元',
          number: 2
        },
        {
          key: 'mark',
          label: '备注',
          type: 'input',
          span: 24
        },
        {
          key: 'policyImage',
          label: '保单图片',
          type: 'upload',
          autoUpload: false,
          span: 24
        }
      ]
    },
    maintenance: {
      name: 'maintenance',
      title: '维修保养登记',
      deleteFun: 'maintenance/deleteMaintenance',
      addFun: 'maintenance/addMaintenance',
      editFun: 'maintenance/editMaintenance',
      getListFun: 'officialCar/getOfficialCarEnterInfo',
      getParentFun: 'officialCar/getOfficialCarList',
      headButtons: setCheckButtons(['新增']),
      detailPage: [
        {
          buttonName: '新增',
          name: 'maintenance',
          type: 'dialogForm'
        },
        {
          buttonName: '编辑',
          name: 'maintenance',
          type: 'dialogForm',
          checkType: 'useRowData'
        },
        {
          buttonName: '维修保养单据',
          name: 'maintenance',
          type: 'preview'
        }
      ],
      showSummary: true,
      rowData: (params) => {
        return params.state.maintenance.maintainList
      },
      columns: (params) => {
        var columns = [
          {
            label: '维修保养日期',
            prop: 'maintenanceDate'
          },
          {
            label: '维修保养人',
            prop: 'maintenancePerson'
          },
          {
            label: '维修保养类型',
            prop: 'maintenanceType',
            tag: [
              { label: '保养', type: 'success' },
              { label: '小修', type: 'warning' },
              { label: '大修', type: 'danger' },
              { label: '标定', type: 'info' },
              { label: '检验', type: '' }
            ]
          },
          {
            label: '下次保养日期',
            prop: 'nextMaintainDate'
          },
          {
            label: '维修保养费用(元)',
            prop: 'maintenanceCost'
          },
          {
            label: '维修保养内容',
            prop: 'maintenanceContent',
            width: '500px'
          },
          {
            label: '维修保养单据',
            prop: 'maintenanceDocumentInfo',
            drillDown: true
          }
        ]
        if (
          params.state.officialCar.officialCarInfo.vprojectUid ===
            params.orgValue ||
          params.state.officialCar.officialCarInfo.laborCompanyUid ===
            params.orgValue
        ) {
          columns.push({
            label: '操作',
            buttons: setTableButtons(['编辑', '删除'])
          })
        }
        return columns
      },
      manualUpload: true,
      formParams: {
        maintainEntityUid: (params) => {
          return params.state.officialCar.officialCarInfo.carUid
        },
        maintainEntity: (params) => {
          return params.state.officialCar.officialCarInfo.carCode
        },
        maintenancePerson: (params) => {
          return isTzInspectionOrg(params)
            ? TZ_INSPECTION_ORG_NAME
            : params.state.officialCar.officialCarInfo.ownerName
        },
        maintenanceType: (params) => {
          return isTzInspectionOrg(params) ? '检验' : '保养'
        },
        maintenanceDate: daysFormat(new Date()),
        nextMaintainDate: '',
        maintenanceContent: '',
        maintenanceCost: '',
        maintenanceDocument: [],
        fileLists: {
          maintenanceDocument: []
        }
      },
      formRules: {
        maintenancePerson: [
          {
            required: true,
            message: '维修保养人不能为空',
            trigger: 'blur'
          }
        ],
        maintenanceType: [
          {
            required: true,
            message: '维修保养类型不能为空',
            trigger: 'change'
          }
        ],
        maintenanceDate: [
          {
            required: true,
            message: '维修保养时间不能为空',
            trigger: 'blur'
          }
        ]
      },
      formData: [
        {
          key: 'maintenanceType',
          label: '维修保养类型',
          type: 'select',
          options: (params) => {
            return params.dictionarys.maintenanceType
          }
        },
        {
          key: 'maintenancePerson',
          label: '维修保养人',
          type: 'input'
        },
        {
          key: 'maintenanceDate',
          label: '维修保养日期',
          type: 'time',
          format: 'yyyy-MM-dd'
        },
        {
          key: 'nextMaintainDate',
          label: '下次保养日期',
          type: 'time',
          format: 'yyyy-MM-dd'
        },
        {
          key: 'maintenanceCost',
          label: '维修保养费用',
          type: 'input',
          inputButton: '元',
          number: 2
        },
        {
          key: 'maintenanceContent',
          label: '维修保养内容',
          type: 'input',
          inputType: 'textarea',
          autosize: true,
          span: 24
        },
        {
          key: 'maintenanceDocument',
          label: '维修保养单据',
          type: 'upload',
          autoUpload: false,
          span: 24
        }
      ]
    },
    device: {
      name: 'monitoring',
      title: '监控设备信息',
      deleteFun: 'device/deleteDeviceRelevance',
      addFun: 'device/relatedDevice',
      editFun: 'device/editDeviceRelevance',
      getListFun: 'officialCar/getOfficialCarEnterInfo',
      getParentFun: 'officialCar/getOfficialCarList',
      headButtons: setCheckButtons(['新增']),
      detailPage: [
        {
          buttonName: '新增',
          name: 'device',
          type: 'dialogForm'
        },
        {
          buttonNames: ['编辑', '查看'],
          name: 'device',
          type: 'dialogForm',
          checkType: 'useRowData'
        }
      ],
      rowKey: 'relatedUid',
      rowData: (params) => {
        return params.state.device.deviceList
      },
      columns: (params) => {
        var columns = [
          {
            label: '物联设备编号',
            prop: 'deviceCode'
          },
          {
            label: '物联设备名称',
            prop: 'deviceName'
          },
          {
            label: '物联设备类型',
            prop: 'deviceType'
          },
          {
            label: '物联设备服务商',
            prop: 'deviceService'
          },
          {
            label: '设备参数',
            prop: 'params'
          }
        ]
        if (
          params.state.officialCar.officialCarInfo.vprojectUid ===
            params.orgValue ||
          params.state.officialCar.officialCarInfo.laborCompanyUid ===
            params.orgValue
        ) {
          columns.push({
            label: '操作',
            buttons: setTableButtons(['编辑', '删除'])
          })
        }
        return columns
      },
      formParams: {
        monitoredEntityUid: (params) => {
          return params.state.officialCar.officialCarInfo.carUid
        },
        monitoredEntity: (params) => {
          return params.state.officialCar.officialCarInfo.carCode
        },
        entryUid: (params) => {
          return params.state.officialCar.officialCarInfo.uid
        },
        deviceUid: '',
        deviceCode: '',
        thirdDeviceCode: '',
        deviceType: '',
        deviceName: '',
        deviceService: '',
        params: ''
      },
      formRules: {
        deviceUid: [
          {
            required: true,
            message: '设备编号不能为空',
            trigger: 'blur'
          }
        ],
        deviceType: [
          {
            required: true,
            message: '设备类型不能为空',
            trigger: 'blur'
          }
        ],
        deviceName: [
          {
            required: true,
            message: '设备名称不能为空',
            trigger: 'blur'
          }
        ],
        deviceService: [
          {
            required: true,
            message: '设备服务商不能为空',
            trigger: 'blur'
          }
        ]
      },
      formData: (params) => {
        var formData = [
          {
            key: 'deviceUid',
            label: '设备编号',
            type: 'select',
            options: params.state.device.devices,
            placeholder: '请输入设备编号在设备库中检索',
            checkByValue: true,
            filterable: true,
            remote: true,
            span: 24
          },
          {
            key: 'deviceName',
            label: '设备名称',
            type: 'input',
            disabled: true
          },
          {
            key: 'deviceType',
            label: '设备类型',
            type: 'input',
            disabled: true
          },
          {
            key: 'deviceService',
            label: '设备服务商',
            type: 'input',
            disabled: true
          },
          {
            key: 'params',
            label: '设备参数',
            type: 'input',
            disabled: true
          }
        ]
        return formData
      }
    },
    paramJson: {
      name: 'paramJson',
      title: '车辆参数指标',
      editFun: 'officialCar/editOfficialCar',
      getParentFun: 'officialCar/getOfficialCarList',
      formParams: {
        uid: '',
        paramJson: []
      },
      formRules: (params) => {
        var formRules = {}
        if (params.formValues && params.formValues.paramJson) {
          params.formValues.paramJson.forEach((item, index) => {
            formRules['key' + (index + 1)] = [
              {
                required: true,
                message: '请输入英文字母或数字组成的键名',
                trigger: 'blur'
              },
              {
                pattern: /\w/g,
                message: '请输入英文字母或数字',
                trigger: 'blur'
              }
            ]
            formRules['label' + (index + 1)] = [
              {
                required: true,
                message: '请输入设备参数名称',
                trigger: 'blur'
              }
            ]
            formRules['value' + (index + 1)] = [
              {
                required: true,
                message: '请输入设备参数值',
                trigger: 'blur'
              }
            ]
          })
        }
        return formRules
      },
      formData: (params) => {
        var formData = [
          {
            type: 'button',
            buttons: [
              { name: '添加设备参数', type: 'primary', icon: 'el-icon-plus' }
            ],
            span: 24
          }
        ]
        if (params.formValues && params.formValues.paramJson) {
          params.formValues.paramJson.forEach((item, index) => {
            const key = {
              key: 'key' + (index + 1),
              label: '参数' + (index + 1) + '键名',
              type: 'input',
              span: 12,
              buttonIcon: 'el-icon-delete-solid'
            }
            const label = {
              key: 'label' + (index + 1),
              label: '参数' + (index + 1) + '名称',
              type: 'input',
              span: 12
            }

            const value = {
              key: 'value' + (index + 1),
              label: '参数' + (index + 1) + '值',
              type: 'input',
              span: 12
            }
            const unit = {
              key: 'unit' + (index + 1),
              label: '参数' + (index + 1) + '单位',
              type: 'input',
              span: 12
            }
            formData.splice(-1, 1, key, label, value, unit, {
              type: 'button',
              buttons: [
                { name: '添加设备参数', type: 'primary', icon: 'el-icon-plus' }
              ],
              span: 24
            })
          })
        }
        return formData
      }
    }
  },
  fixedEquipment: {
    name: 'fixedEquipment',
    componentTypes: [
      'navigate',
      'pageTabs',
      'check',
      'tables',
      'stepForm',
      'drawerTable',
      'dialogForm',
      'deviceData'
    ],
    addFun: 'officialCar/addOfficialCar',
    editFun: 'officialCar/editOfficialCarEnter',
    getListFun: 'officialCar/getOfficialCarList',
    deleteFun: 'officialCar/deleteOfficialCarEnter',
    detailPage: [
      {
        buttonName: '进场',
        name: 'fixedEquipment',
        type: 'stepForm',
        theme: 'officialCar',
        step: 'fixedEquipmentInfo',
        label: '新增固定机械进场信息',
        pageStatus: 'add'
      },
      {
        buttonName: '编辑',
        name: 'fixedEquipment',
        type: 'stepForm',
        theme: 'officialCar',
        step: 'fixedEquipmentInfo',
        label: '编辑固定机械进场信息',
        checkType: 'checkByUid',
        checkFun: 'officialCar/getOfficialCarEnterInfo'
      },
      {
        buttonName: '查看',
        name: 'fixedEquipment',
        type: 'stepForm',
        theme: 'officialCar',
        step: 'fixedEquipmentInfo',
        label: '查看固定机械进场信息',
        checkType: 'checkByUid',
        checkFun: 'officialCar/getOfficialCarEnterInfo'
      },
      ...EQUIPMENT_LINK_PAGES
    ],
    headButtons: setCheckButtons(['进场']),
    queryParams: {
      orgUid: (params) => listOrgUid(params),
      vprojectUid: (params) => bidQueryUid(params),
      laborCompanyUid: (params) => {
        return isLaborCompanyOrg(params.orgType) ? params.orgValue : ''
      },
      exit: null,
      inspectExpired: '',
      hasGps: '',
      hasMonitoring: '',
      carUsage: '',
      query: '',
      isExpired: '',
      deviceCategory: '固定设备'
    },
    selectData: (params) => {
      const tz = isTzInspectionOrg(params)
      const selectData = []
      if (!isLaborCompanyOrg(params.orgType)) {
        selectData.push({
          key: 'vprojectUid',
          label: '所属项目标段',
          type: 'select',
          options: bidFilterOptions(params),
          checkByValue: true
        })
        if (showLaborCompanyQuery(params)) {
          selectData.push({
            key: 'laborCompanyUid',
            label: '所属劳务公司',
            type: 'select',
            options: params.state.bidSection.laborCompanyNames,
            placeholder: '请先选择所属项目标段',
            checkByValue: true
          })
        }
      }
      selectData.push({
        key: tz ? 'inspectExpired' : 'exit',
        label: tz ? '是否过期' : '是否在场',
        type: 'select',
        options: tz
          ? [
              { value: '1', label: '已过期', type: 'danger' },
              { value: '0', label: '未过期' }
            ]
          : params.dictionarys.trueFalse,
        checkByValue: true
      })
      if (!tz) {
        selectData.push(
          {
            key: 'isExpired',
            label: '保险状态',
            type: 'select',
            options: params.dictionarys.isExpired
          },
          {
            key: 'hasMonitoring',
            label: '是否监控',
            type: 'select',
            options: params.dictionarys.isFalse
          }
        )
      }
      selectData.push(
        {
          key: 'carUsage',
          label: '设备用途',
          type: 'select',
          options: DEVICE_USAGE_OPTIONS
        },
        {
          key: 'query',
          label: '关键词',
          type: 'input',
          placeholder: tz
            ? '设备名称/设备型号/所有人/检验机构'
            : '设备名称/设备型号/所有人/操作手'
        }
      )
      return selectData
    },
    tagInfo:
      '固定机械状态保持页面打开初次或前一次点击查询按钮查询结果，想要查看最新状态，请点击查询按钮重新查询',
    outListHeight: (params) => {
      return isLaborCompanyOrg(params.orgType) ? 230 : 270
    },
    rowData: (params) => params.getters['officialCar/carLists'],
    rowTotal: (params) => {
      return params.state.officialCar.officialCarTotal
    },
    columns: (params) => {
      const tz = isTzInspectionOrg(params)
      return [
        {
          prop: 'carName',
          label: '设备名称',
          tooltip: () => {
            return (row) => {
              return { tipValue: row.laborCompanyName }
            }
          }
        },
        {
          prop: tz ? 'ownerName' : 'driverName',
          label: tz ? '所有人' : '操作手',
          tooltip: () => {
            return (row) => {
              return { tipValue: tz ? row.ownerPhone : row.driverPhone }
            }
          },
          width: tz ? '160px' : '80px'
        },
        {
          prop: 'carUsage',
          label: '设备用途',
          tooltip: () => {
            return (row) => {
              return { tipValue: row.carModel }
            }
          },
          tag: DEVICE_USAGE_OPTIONS
        },
        {
          prop: 'entryDate',
          label: tz ? '初次检验日期' : '进场日期'
        },
        ...(tz
          ? [
              {
                prop: 'latestMaintainDate',
                label: '最近检验日期',
                drillDown: true,
                tooltip: { tipValue: '点击查看维修保养详情' }
              },
              {
                prop: 'inspectExpired',
                label: '是否过期',
                switch: 'nextMaintainDate',
                width: '160px'
              }
            ]
          : [
              {
                prop: 'exit',
                label: '是否退场',
                switch: 'exitDate',
                width: '140px'
              }
            ]),
        ...statusColumns(params),
        {
          label: '操作',
          width: tz ? '220px' : '280px',
          buttons: tableActionButtons(params)
        }
      ]
    },
    addArray: true,
    formParams: {
      vprojectUid: (params) => formBidUid(params),
      vprojectName: (params) => formBidName(params),
      laborCompanyUid: (params) => {
        return isLaborCompanyOrg(params.orgType) ? params.orgValue : ''
      },
      laborCompanyName: (params) => {
        return isLaborCompanyOrg(params.orgType)
          ? getLaborCompanyName(params)
          : ''
      },
      carName: '',
      carCode: '',
      carModel: '',
      ownerName: '',
      ownerCardNum: '',
      ownerPhone: '',
      driverName: (params) => {
        return isTzInspectionOrg(params) ? TZ_INSPECTION_ORG_NAME : ''
      },
      driverIdcard: '',
      driverPhone: '',
      entryDate: daysFormat(new Date()),
      exit: false,
      exitDate: '',
      carUsage: (params) => {
        return isTzInspectionOrg(params) ? '燃油运输' : ''
      },
      deviceCategory: '固定设备',
      vehicleLicense: [],
      fileLists: {
        vehicleLicense: []
      },
      isCheck: (params) => isTzInspectionOrg(params)
    },
    formRules: (params) => {
      const tz = isTzInspectionOrg(params)
      return {
        carName: [
          {
            required: true,
            message: '设备名称不能为空',
            trigger: 'blur'
          }
        ],
        ownerName: [
          {
            required: true,
            message: '设备所有人不能为空',
            trigger: 'blur'
          }
        ],
        entryDate: [
          {
            required: true,
            message: tz ? '进场及初检日期不能为空' : '进场日期不能为空',
            trigger: 'blur'
          }
        ]
      }
    },
    formData: (params) => {
      const tz = isTzInspectionOrg(params)
      return {
        card: tz ? '特种设备检验信息' : '固定机械信息',
        bottomButtons: setFormButtons(['取消', '提交']),
        manualUpload: true,
        fields: [
          {
            key: laborCompanyFieldKey(params),
            label: '所属劳务公司',
            type: 'select',
            options: params.state.bidSection.laborCompanyNames,
            placeholder: '请选择进场设备所属劳务公司，项目直管设备不用选择',
            valueKey: 'value',
            bindKeys: ['value', 'label'],
            formKeys: ['laborCompanyUid', 'laborCompanyName']
          },
          {
            key: 'carName',
            label: '设备名称',
            type: 'select',
            options: params.state.officialCar.officialCars,
            placeholder:
              '请输入设备编号、设备名称或所有人搜索，搜不到可直接输入设备名称新增',
            filterable: true,
            create: true,
            remote: true,
            checkByValue: true,
            disabled: params.pageStatus === 'edit' ? true : false,
            inputTip:
              params.pageStatus === 'edit'
                ? '设备名称错误修改请直接删除重新进场'
                : ''
          },
          {
            key: 'carCode',
            label: '设备编号',
            type: 'input',
            placeholder: '请输入设备编号，库中搜不到时手工填写'
          },
          {
            key: 'carModel',
            label: '设备型号',
            type: 'input'
          },
          {
            key: 'ownerName',
            label: tz ? '所有人' : '设备所有人',
            type: 'input'
          },
          {
            key: 'ownerCardNum',
            label: '所有人身份证',
            type: 'input'
          },
          {
            key: 'ownerPhone',
            label: '所有人手机号',
            type: 'input'
          },
          {
            key: 'entryDate',
            label: tz ? '进场及初检日期' : '进场日期',
            type: 'time',
            format: 'yyyy-MM-dd'
          },
          {
            key:
              tz ||
              (params.pageStatus !== 'edit' && params.pageStatus !== 'check')
                ? null
                : 'exitDate',
            label: '退场日期',
            type: 'time',
            format: 'yyyy-MM-dd'
          },
          {
            key: 'driverName',
            label: tz ? '检验机构' : '操作手姓名',
            type: tz ? 'input' : 'select',
            options: tz
              ? []
              : params.formValues && params.formValues.laborCompanyUid
              ? params.state.contractor.laborPersonNames
              : params.state.contractor.managePersonNames,
            filterable: !tz,
            create: !tz
          },
          tz
            ? { key: null }
            : {
                key: 'driverIdcard',
                label: '操作手身份证',
                type: 'input'
              },
          tz
            ? { key: null }
            : {
                key: 'driverPhone',
                label: '操作手手机号',
                type: 'input'
              },
          {
            key: 'carUsage',
            label: '设备用途',
            type: 'select',
            options: DEVICE_USAGE_OPTIONS,
            filterable: true,
            create: true,
            placeholder: '请选择或输入设备用途'
          },
          {
            key: 'vehicleLicense',
            label: '设备证件',
            type: 'upload',
            autoUpload: false
          }
        ]
      }
    },
    hasPagination: true
  },
  deviceData: {
    name: 'deviceData',
    componentTypes: ['navigate', 'deviceData'],
    cardTitle: '物联监控数据信息',
    formTitle: '工程用车信息',
    formData: (params) => {
      var formData = [
        {
          key: 'laborCompanyName',
          label: '所属劳务公司',
          type: 'text'
        },
        {
          key: 'carCode',
          label: '车牌号',
          type: 'text'
        },
        {
          key: 'carModel',
          label: '车辆型号',
          type: 'text'
        },
        {
          key: 'approvedPenson',
          label: '核载人数',
          type: 'text'
        },
        {
          key: 'limitSpeed',
          label: '最大限速(km/h)',
          type: 'text'
        },
        {
          key: 'entryDate',
          label: '进场日期',
          type: 'text'
        },
        {
          key: 'driverName',
          label: '司机姓名',
          type: 'text'
        },
        {
          key: 'driverPhone',
          label: '司机手机号码',
          type: 'text'
        }
      ]
      if (params.pageStatus === 'current') {
        formData.push(
          {
            key: 'ownerName',
            label: '车主姓名',
            type: 'text'
          },
          {
            key: 'ownerPhone',
            label: '车主手机号码',
            type: 'text'
          },
          {
            key: 'carUsage',
            label: '车辆用途',
            type: 'text'
          },
          {
            key: 'stateCn',
            label: '车辆状态',
            type: 'tag'
          },
          {
            key: 'speed',
            label: '速度(km/h)',
            type: 'text'
          },
          {
            key: 'isOverSpeed',
            label: '是否超速',
            type: 'tag'
          },
          {
            key: 'addr',
            label: '当前位置',
            type: 'text'
          }
        )
      } else if (params.pageStatus === 'history') {
        formData.push(
          {
            key: 'mile',
            label: '行驶里程（km）',
            type: 'text'
          },
          {
            key: 'move_long',
            label: '行车时长',
            type: 'text'
          },
          {
            key: 'max_speed',
            label: '最高速度(km/h)',
            type: 'text'
          },
          {
            key: 'avg_speed',
            label: '平均速度(km/h)',
            type: 'text'
          },
          {
            key: 'overspeedNum',
            label: '超速次数',
            type: 'text'
          },
          {
            key: 'stop_long',
            label: '停车时长',
            type: 'text'
          },
          {
            key: 'stopNum',
            label: '停车次数',
            type: 'text'
          }
        )
      }
      return formData
    }
  }
}

officialCar.fixedEquipment.insurance = officialCar.officialCar.insurance
officialCar.fixedEquipment.maintenance = officialCar.officialCar.maintenance
officialCar.fixedEquipment.device = officialCar.officialCar.device
officialCar.fixedEquipment.paramJson = officialCar.officialCar.paramJson

export default officialCar
